import { render, staticRenderFns } from "./Emissoes.vue?vue&type=template&id=bca8865a&"
import script from "./Emissoes.vue?vue&type=script&lang=js&"
export * from "./Emissoes.vue?vue&type=script&lang=js&"
import style0 from "./Emissoes.vue?vue&type=style&index=0&id=bca8865a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports